import { createContext } from '@lit/context';
export const selectTokenContext = createContext(Symbol('select token context'));
//# sourceMappingURL=context.js.map